import {Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {QstateService, StateVariant} from './service/qstate.service';
import {Observable} from 'rxjs';
import {FormBuilder} from '@angular/forms';

@Component({
  selector: 'app-quest',
  templateUrl: './quest.component.html',
  styleUrls: ['./quest.component.scss'],
})
export class QuestComponent implements OnInit {
  stateVariant = StateVariant;
  questions: Observable<any>[];
  current: any;
  errorMsg = '';
  @ViewChild('field', {static: false}) field: ElementRef<HTMLInputElement>;
  constructor(public stateService: QstateService) { }

  ngOnInit() {

  }

  startPressed() {
    this.stateService.questionNum++;
    this.stateService.state = this.stateVariant.Start;
    this.stateService.getQuestions().subscribe((data: any) => {
      this.questions = data;
      this.current = this.questions[0];
    });
  }

  nextPressed() {
    this.errorMsg = '';
    const fieldConverted = this.convertValue(this.field.nativeElement.value);
    const answerConverted = this.convertValue(this.current.answers[0]);
    if (this.field.nativeElement.value === this.current.answers[0] || this.current.answers.includes(this.field.nativeElement.value)) {
      this.nextQuestion();
    } else {
      this.errorMsg = 'Ви помилилися';
    }
  }
  convertValue(text: string): string {
    return text.toLowerCase().replace(/\s/g, '').replace(/-/g, '');
  }
  nextQuestion() {
    this.field.nativeElement.value = '';
    this.field.nativeElement.focus();
    this.current = this.questions[this.stateService.questionNum];
    if (this.current) {
      this.stateService.questionNum++;
    } else {
      this.stateService.state = this.stateVariant.End;
    }
    console.log(this.current);
  }
}
